import React from 'react'
import { Progress } from 'antd';
import PersianNumber from '../../../shared/PersianNumber';

const TotaolReserve = ({StatisticInfo}) => {
  return (
    <div className='TotaolReserve ReserveCounts'>
    
     <h3 className="UserStatics--h3 mb-[20px]">کل درخواست رزرو</h3>
    <div className='d-flex-space'>
    <div className="d-flex gap-[8px] mb-[8px]">
       <div className="circle-green"></div>
       <div className="legande-text">رد شده : <span><PersianNumber number={StatisticInfo.count_failed_reserve} /></span></div>

     </div>
     <div className="d-flex gap-[8px]">
       <div className="circle-orang"></div>
       <div className="legande-text">تایید شده :  <span><PersianNumber number={StatisticInfo.count_successful_reserve} /></span></div>

     </div>
    </div>
    <p >مجموع 
      
      <PersianNumber number={StatisticInfo.count_failed_reserve + StatisticInfo.count_successful_reserve} />
       درخواست برای  رزرو اقامتگاه</p>

   
     
        <div className='relative w-max mx-auto'>
      <div className='first-circleprogressbar'>
      <Progress type="circle" percent={(StatisticInfo.count_failed_reserve /100)*100} strokeColor="#00A6A6" strokeWidth={8} trailColor='#F0F5F7'/>
      </div>
        <div className='sec-circleprogressbar'>
        <Progress type="circle" percent={(StatisticInfo.count_successful_reserve /100)*100} strokeColor="#F48E2F" strokeWidth={10} trailColor='#F0F5F7'/>

        </div>
        </div>
    </div>
  )
}

export default TotaolReserve